(function() {
  function ofertaActiva() {
    const fin = parseInt(localStorage.getItem('cabana_envio_fin') || '0', 10);
    return Date.now() < fin;
  }

  function tiempoRestanteMs() {
    const fin = parseInt(localStorage.getItem('cabana_envio_fin') || '0', 10);
    return Math.max(0, fin - Date.now());
  }

  function aplicarBoost() {
    document.querySelectorAll('.cabana-ahorro').forEach(function(el) {
      const base = parseFloat(el.dataset.ahorroBase);
      const envio = parseFloat(el.dataset.envioGratis);
      const texto = el.querySelector('.cabana-ahorro__text');
      const envioLinea = el.querySelector('.cabana-ahorro__envio');
      if (!texto || !envioLinea) return;

      texto.textContent = 'Ahorras S/. ' + (base + envio).toFixed(2) + ' en esta compra';
      envioLinea.style.display = 'block';
    });
  }

  function revertirBoost() {
    document.querySelectorAll('.cabana-ahorro').forEach(function(el) {
      const base = parseFloat(el.dataset.ahorroBase);
      const texto = el.querySelector('.cabana-ahorro__text');
      const envioLinea = el.querySelector('.cabana-ahorro__envio');
      if (!texto || !envioLinea) return;

      texto.textContent = 'Ahorras S/. ' + base.toFixed(2) + ' en esta compra';
      envioLinea.style.display = 'none';
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    if (ofertaActiva()) {
      aplicarBoost();
      setTimeout(revertirBoost, tiempoRestanteMs());
    }
  });
})();